import * as constants from '@redbubble/design-system/src/constants';
import { FieldMessage } from '@redbubble/design-system/src/Form';
import { defineMessages, useIntl } from '@redbubble/next/intl';

export enum ErrorType {
  Required = 'required',
}

export const messages = defineMessages({
  [ErrorType.Required]: {
    defaultMessage: 'Please choose an option first.',
  },
});

const InputErrorMessage = ({
  errorType = ErrorType.Required,
}: {
  errorType: ErrorType;
}) => {
  const intl = useIntl();

  return (
    <FieldMessage intent={constants.ERROR}>
      {intl.formatMessage(messages[errorType])}
    </FieldMessage>
  );
};

export { InputErrorMessage };
